import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useForgeTheme } from '../../../forge/hooks/useForgeTheme';
import { useSidebar } from '../../../forge/hooks/useSidebar';
import '../../../forge/styles/forge-theme.css';
import '../../styles/eval-theme.css';
import { EvalSidebar } from './EvalSidebar';

export const EvalLayout: React.FC = () => {
  const { theme, toggleTheme } = useForgeTheme();
  const { width, isCollapsed, isResizing, toggleCollapse, onDragStart } = useSidebar();
  const location = useLocation();

  return (
    <div className="forge-root" data-forge-theme={theme}>
      <div className="forge-layout">
        <EvalSidebar
          theme={theme}
          width={width}
          isCollapsed={isCollapsed}
          isResizing={isResizing}
          toggleCollapse={toggleCollapse}
          onDragStart={onDragStart}
          toggleTheme={toggleTheme}
          currentPath={location.pathname}
        />
        <main
          className={`forge-main-content ${isResizing ? 'sidebar-resizing' : ''}`}
          style={{ marginLeft: isCollapsed ? 44 : width }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
};
